import React, { FunctionComponent } from 'react';

import FilterAltIcon from '@mui/icons-material/FilterAlt';
import { useTheme } from '@mui/material';

export const FilterFlag: FunctionComponent = () => {
  const theme = useTheme();
  return (
    <FilterAltIcon sx={{ marginLeft: 0.5, color: theme.palette.grey[500] }} />
  );
};
